
import Case1Avatar from './../../assets/images/homepage/case/case1.webp'
import Case1AvatarPNG from './../../assets/images/homepage/case/case1.png'
import Case1Logo from './../../assets/images/homepage/case/case1-logo.webp'
import Case1LogoPNG from './../../assets/images/homepage/case/case1-logo.png'
import Case2Avatar from './../../assets/images/homepage/case/case2.webp'
import Case2AvatarPNG from './../../assets/images/homepage/case/case2.png'
import Case2Logo from './../../assets/images/homepage/case/case2-logo.webp'
import Case2LogoPNG from './../../assets/images/homepage/case/case2-logo.png'
import Case3Avatar from './../../assets/images/homepage/case/case3.webp'
import Case3AvatarPNG from './../../assets/images/homepage/case/case3.png'
import Case3Logo from './../../assets/images/homepage/case/case3-logo.webp'
import Case3LogoPNG from './../../assets/images/homepage/case/case3-logo.png'
import Case4Avatar from './../../assets/images/homepage/case/case4.webp'
import Case4AvatarPNG from './../../assets/images/homepage/case/case4.png'
import Case4Logo from './../../assets/images/homepage/case/case4-logo.webp'
import Case4LogoPNG from './../../assets/images/homepage/case/case4-logo.png'
import Case5Avatar from './../../assets/images/homepage/case/case5.webp'
import Case5AvatarPNG from './../../assets/images/homepage/case/case5.png'
import Case5Logo from './../../assets/images/homepage/case/case5-logo.webp'
import Case5LogoPNG from './../../assets/images/homepage/case/case5-logo.png'

const Data = [
    {
        "id": "1",
        "link": "/empower/Digital%20Empowerment%20Philips%20Acer",
        "avatar": Case1Avatar,
        "avatarPNG": Case1AvatarPNG,
        "logo": Case1Logo,
        "logoPNG": Case1LogoPNG,
    },
    {
        "id": "2",
        "link": "/empower/Digital%20Empowerment%20Cosmos%20Hotel",
        "avatar": Case2Avatar,
        "avatarPNG": Case2AvatarPNG,
        "logo": Case2Logo,
        "logoPNG": Case2LogoPNG,
    },
    {
        "id": "3",
        "link": "/empower/Digital%20Empowerment%20PSIM",
        "avatar": Case3Avatar,
        "avatarPNG": Case3AvatarPNG,
        "logo": Case3Logo,
        "logoPNG": Case3LogoPNG,

    },
    {
        "id": "4",
        "link": "/empower/Venture%20Studio%20TEXTIP",
        "avatar": Case4Avatar,
        "avatarPNG": Case4AvatarPNG,
        "logo": Case4Logo,
        "logoPNG": Case4LogoPNG,
    },
    {
        "id": "5",
        "link": "/empower/Venture%20Studio%20leAD%20insight",
        "avatar": Case5Avatar,
        "avatarPNG": Case5AvatarPNG,
        "logo": Case5Logo,
        "logoPNG": Case5LogoPNG,
    }
]
export default Data;